//CSS

import styles from "./Navbar.module.css";

//Components

import NavbarListItem from "./NavbarItem/NavbarItem";

//Data

import { NavbarData, isLegacyMesmaNavItem, LEGACY_MESMA_APP_ORIGIN } from "../../Data/NavbarData";

import { isLegacyDrawerItemVisible } from "../../Data/legacyNavItemGate";

import {

  getAdminDisabledMessage,

  getLegacyNavDisabledReasonText,

  getModuleNotSubscribedMessage,

  getModulePermissionDeniedMessage,

} from "../../Data/legacyNavMessages";

import { useState, useEffect } from "react";

import { useLocation } from "react-router-dom";

import { NavbarItem } from "../../Types/NavbarItem";

import { useAppSelector } from "../../Redux/Store/Store";

import {

  getCanAccessDevelop,

  getCanAccessEvaluate,

  getCanAccessTrack,

  getClient,

  getDevelopDeniedReason,

  getEvaluateDeniedReason,

  getGen3RedirectEnabled,

  getLibraryGen3Enabled,

  getIsClientAdmin,

  getLegacyBlazorNavVisibility,

  getTrackDeniedReason

} from "../../Redux/Store/Slices/client";

import { NavbarAccessDeniedReason } from "../../Types/Navbar/NavbarAccess";

import { IsMesmaDev } from "../../Helpers/Permissions";

import { useMediaQuery } from "../../Hooks/useMediaQuery";



const MOBILE_BREAKPOINT = "(max-width: 960px)";



type RenderNavItemOptions = {

  disabled?: boolean;

  disabledReason?: string;

  align?: "top" | "bottom";

};



const Navbar = () => {

  const user = useAppSelector((state) => state.auth.user);

  const location = useLocation();

  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);



  const isClientAdmin = useAppSelector(getIsClientAdmin)

  const canAccessEvaluate = useAppSelector(getCanAccessEvaluate);

  const canAccessTrack = useAppSelector(getCanAccessTrack);

  const canAccessDevelop = useAppSelector(getCanAccessDevelop);

  const evaluateDeniedReason = useAppSelector(getEvaluateDeniedReason);

  const trackDeniedReason = useAppSelector(getTrackDeniedReason);

  const developDeniedReason = useAppSelector(getDevelopDeniedReason);

  const legacyBlazorNav = useAppSelector(getLegacyBlazorNavVisibility)

  const gen3RedirectEnabled = useAppSelector(getGen3RedirectEnabled)

  const libraryGen3Enabled = useAppSelector(getLibraryGen3Enabled)

  const activeClient = useAppSelector(getClient)

  const clientName = activeClient?.name



  let topNavItems: NavbarItem[] = [];

  let bottomNavItems: NavbarItem[] = [];



  const items = NavbarData.flatMap((item) => {
    if (item.type !== "navigation" || item.id !== 9) {
      return [item];
    }
    if (libraryGen3Enabled === undefined) {
      return [];
    }
    if (libraryGen3Enabled) {
      return [item];
    }
    return [{
      ...item,
      id: 19,
      url: `${LEGACY_MESMA_APP_ORIGIN}/Library`,
    }];
  });



  const [navItemStatus, setNavItemStatus] = useState([...NavbarData]);

  const [isExpanded, setIsExpanded] = useState(false);



  // Close nav overlay when route changes (mobile)

  useEffect(() => {

    setIsExpanded(false);

  }, [location.pathname]);



  const isRunningStandalone = (): boolean => {

    return window.matchMedia("(display-mode: standalone)").matches;

  };



  const removeActiveStatus = (): void => {

    const state: NavbarItem[] = [...navItemStatus];

    state.forEach((element) => {

      element.active = false;

    });

  };



  const addActiveStatus = (id: number) => {

    // Destructure current state array

    const state: NavbarItem[] = [...navItemStatus];

    state.forEach((element) => {

      element.active = false;

    });



    // Find object from id. Classic Library uses a stand-in id that is not in this list.

    let index = state.findIndex((x) => x.id === id);

    if (index >= 0) {
      state[index].active = true;
    }



    // Set state with updated active status

    setNavItemStatus(() => {

      return [...state];

    });

  };



  const toggleDrawer = () => {

    setIsExpanded(!isExpanded);

  };



  const sortNavItems = () => {

    for (let i = 0; i < items.length; i++) {

      if (items[i].id > 7) {

        bottomNavItems.push(items[i]);

      } else {

        topNavItems.push(items[i]);

      }

    }

  };



  const showLimitedNavItems = (): void => {

    items.splice(4);

  };



  if (!isRunningStandalone()) {

    sortNavItems();

  } else {

    showLimitedNavItems();

  }



  removeActiveStatus();



  const isStandalone = isRunningStandalone();

  const isOverlayMode = isMobile && !isStandalone;



  const getEvaluateDisabledReasonText = (): string => {

    switch (evaluateDeniedReason) {

      case NavbarAccessDeniedReason.MissingLicense:

        return getModulePermissionDeniedMessage("Evaluate");

      case NavbarAccessDeniedReason.SubscriptionDisabled:

        return getModuleNotSubscribedMessage("Evaluate", clientName);

      default:

        return getModulePermissionDeniedMessage("Evaluate");

    }

  };



  const getTrackDisabledReasonText = (): string => {

    switch (trackDeniedReason) {

      case NavbarAccessDeniedReason.MissingLicense:

        return getModulePermissionDeniedMessage("Track");

      case NavbarAccessDeniedReason.SubscriptionDisabled:

        return getModuleNotSubscribedMessage("Track", clientName);

      default:

        return getModulePermissionDeniedMessage("Track");

    }

  };



  const getDevelopDisabledReasonText = (): string => {

    switch (developDeniedReason) {

      case NavbarAccessDeniedReason.DevelopFeatureDisabled:

      case NavbarAccessDeniedReason.SubscriptionDisabled:

        return getModuleNotSubscribedMessage("Develop", clientName);

      case NavbarAccessDeniedReason.MissingLicense:

        return getModulePermissionDeniedMessage("Develop");

      default:

        return getModulePermissionDeniedMessage("Develop");

    }

  };



  const topAlignedItems = items.filter((item) => (item.align ?? "top") === "top");

  const mainTopNavItems = topAlignedItems.filter((item) => !isLegacyMesmaNavItem(item));

  const legacyTopNavItems = topAlignedItems

    .filter((item) => isLegacyMesmaNavItem(item))

    .filter((item) => gen3RedirectEnabled || item.id === 19)

    .map((item) => ({

      item,

      isEnabled: isLegacyDrawerItemVisible(item, legacyBlazorNav, isClientAdmin),

    }));



  const renderTopNavItem = (item: NavbarItem, options: RenderNavItemOptions = {}) => {

    const forceDisabled = options.disabled ?? false;

    const itemAlign = options.align ?? "top";



    if (item.id === 5) {

      return (

        <NavbarListItem

          item={item}

          key={item.id}

          statusHandler={addActiveStatus}

          align={isStandalone ? "top" : "bottom"}

          disabled={!canAccessTrack || forceDisabled}

          disabledReason={

            forceDisabled

              ? options.disabledReason ?? getTrackDisabledReasonText()

              : getTrackDisabledReasonText()

          }

        />

      );

    }

    if (item.id === 4) {

      return (

        <NavbarListItem

          item={item}

          key={item.id}

          statusHandler={addActiveStatus}

          disabled={!canAccessEvaluate || forceDisabled}

          disabledReason={

            forceDisabled

              ? options.disabledReason ?? getEvaluateDisabledReasonText()

              : getEvaluateDisabledReasonText()

          }

        />

      );

    }

    if (item.id === 6) {

      return (

        <NavbarListItem

          item={item}

          key={item.id}

          statusHandler={addActiveStatus}

          disabled={!canAccessDevelop || forceDisabled}

          disabledReason={

            forceDisabled

              ? options.disabledReason ?? getDevelopDisabledReasonText()

              : getDevelopDisabledReasonText()

          }

        />

      );

    }

    if (item.id === 9) {
      const libraryEnabled = legacyBlazorNav?.showLibrary !== false;
      return (
        <NavbarListItem
          item={item}
          key={item.id}
          statusHandler={addActiveStatus}
          disabled={!libraryEnabled || forceDisabled}
          disabledReason={
            forceDisabled
              ? options.disabledReason ?? getLegacyNavDisabledReasonText(item, legacyBlazorNav, clientName)
              : getLegacyNavDisabledReasonText(item, legacyBlazorNav, clientName)
          }
        />
      );
    }

    if (item.id === 13) {

      return (

        <NavbarListItem

          item={item}

          key={item.id}

          statusHandler={addActiveStatus}

          disabled={!isClientAdmin || forceDisabled}

          disabledReason={

            forceDisabled

              ? options.disabledReason ?? getAdminDisabledMessage(clientName)

              : getAdminDisabledMessage(clientName)

          }

        />

      );

    }

    return (

      <NavbarListItem

        item={item}

        key={item.id}

        statusHandler={addActiveStatus}

        align={itemAlign}

        disabled={forceDisabled}

        disabledReason={

          forceDisabled

            ? options.disabledReason ?? getLegacyNavDisabledReasonText(item, legacyBlazorNav, clientName)

            : undefined

        }

      />

    );

  };



  const legacyList =

    legacyTopNavItems.length > 0 ? (

      <div className={styles.legacyScroll}>

        <ul className={`${styles.topNav} ${styles.legacyNav}`} aria-label="Classic Mesma app">

          {legacyTopNavItems.map(({ item, isEnabled }) =>

            renderTopNavItem(item, {

              disabled: !isEnabled,

              disabledReason: getLegacyNavDisabledReasonText(item, legacyBlazorNav, clientName),

            })

          )}

        </ul>

      </div>

    ) : null;



  const topNavMiddle = (

    <div className={styles.topNavColumn}>

      <div className={styles.topNavMain}>

        <ul className={styles.topNav}>{mainTopNavItems.map((item) => renderTopNavItem(item))}</ul>

      </div>

      {legacyList}

    </div>

  );



  return (

    <>

      {isOverlayMode && (

        <>

          <div

            className={`${styles.navBackdrop} ${isExpanded ? styles.navBackdropVisible : ''}`}

            onClick={() => setIsExpanded(false)}

            aria-hidden

          />

          <button

            type="button"

            className={styles.mobileMenuButton}

            onClick={toggleDrawer}

            aria-label="Open menu"

            aria-expanded={isExpanded}

            style={{ display: isExpanded ? 'none' : 'flex' }}

          >

            <div className={styles.hamburgerIcon}>

              <span></span>

              <span></span>

              <span></span>

            </div>

          </button>

        </>

      )}

      <nav className={`${styles.container} ${isExpanded ? styles.expanded : ''} ${isOverlayMode ? styles.overlay : ''}`}>

      <div className={styles.header}>

        <div className={styles.hamburgerWrapper}>

          <button 

            className={styles.hamburgerButton} 

            onClick={toggleDrawer}

            aria-label="Toggle navigation menu"

          >

            <div className={`${styles.hamburgerIcon} ${isExpanded ? styles.expanded : ''}`}>

              <span></span>

              <span></span>

              <span></span>

            </div>

          </button>

        </div>

        <div className={styles.logoWrapper}>

          <img src="/img/logo.png" alt="Mesma Logo" />

        </div>

      </div>

      {!isStandalone ? (

        <div className={styles.body}>

          {topNavMiddle}

          <div className={styles.bottomNav}>

            {items.filter(item => (item.align ?? "top") === "bottom").map((item) => {

              if(item.id === 15) {

                if (IsMesmaDev(user?.sub)) {

                  return (

                    <NavbarListItem

                      item={item}

                      key={item.id}

                      statusHandler={addActiveStatus}

                      align="bottom"

                    />

                  );

                } else {

                  return null;

                }

              } else {

                return (

                  <NavbarListItem

                    item={item}

                    key={item.id}

                    statusHandler={addActiveStatus}

                    align="bottom"

                  />

                );

              }

            })}

          </div>

          

        </div>

      ) : (

        <div className={styles.body}>

          {topNavMiddle}

          <div className={styles.bottomNav}>

            {items.filter(item => (item.align ?? "top") === "bottom").map((item) => (

              <NavbarListItem

                item={item}

                key={item.id}

                statusHandler={addActiveStatus}

                align="bottom"

              />

            ))}

          </div>

        </div>

      )}

    </nav>

    </>

  );

};



export default Navbar;


